var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_715_2160)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#D3DCEA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0018 11.8725C18.5607 10.7316 17.795 9.74498 16.7993 9.03453C15.8036 8.32408 14.6216 7.92096 13.3993 7.875C12.1769 7.92096 10.9949 8.32408 9.99921 9.03453C9.00351 9.74498 8.23781 10.7316 7.79675 11.8725C7.76697 11.9549 7.76697 12.0451 7.79675 12.1275C8.23781 13.2684 9.00351 14.255 9.99921 14.9655C10.9949 15.6759 12.1769 16.079 13.3993 16.125C14.6216 16.079 15.8036 15.6759 16.7993 14.9655C17.795 14.255 18.5607 13.2684 19.0018 12.1275C19.0315 12.0451 19.0315 11.9549 19.0018 11.8725ZM13.3993 15.375C11.4118 15.375 9.31175 13.9013 8.5505 12C9.31175 10.0988 11.4118 8.625 13.3993 8.625C15.3868 8.625 17.4868 10.0988 18.248 12C17.4868 13.9013 15.3868 15.375 13.3993 15.375Z",
    fill: "#7C8092"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3994 9.75C12.9544 9.75 12.5194 9.88196 12.1494 10.1292C11.7794 10.3764 11.491 10.7278 11.3207 11.139C11.1504 11.5501 11.1058 12.0025 11.1926 12.439C11.2795 12.8754 11.4938 13.2763 11.8084 13.591C12.1231 13.9057 12.524 14.12 12.9605 14.2068C13.3969 14.2936 13.8493 14.249 14.2605 14.0787C14.6716 13.9084 15.023 13.62 15.2702 13.25C15.5175 12.88 15.6494 12.445 15.6494 12C15.6494 11.4033 15.4124 10.831 14.9904 10.409C14.5684 9.98705 13.9962 9.75 13.3994 9.75ZM13.3994 13.5C13.1027 13.5 12.8127 13.412 12.5661 13.2472C12.3194 13.0824 12.1271 12.8481 12.0136 12.574C11.9001 12.2999 11.8704 11.9983 11.9282 11.7074C11.9861 11.4164 12.129 11.1491 12.3388 10.9393C12.5485 10.7296 12.8158 10.5867 13.1068 10.5288C13.3978 10.4709 13.6994 10.5006 13.9734 10.6142C14.2475 10.7277 14.4818 10.92 14.6466 11.1666C14.8114 11.4133 14.8994 11.7033 14.8994 12C14.8994 12.3978 14.7414 12.7794 14.4601 13.0607C14.1788 13.342 13.7972 13.5 13.3994 13.5Z",
    fill: "#7C8092"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_715_2160",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.758333 0 0 0 0 0.758333 0 0 0 0 0.758333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_715_2160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_715_2160",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDetails);
export default __webpack_public_path__ + "static/media/view-details.f90b08befd7bb3b66e71f1723e94adab.svg";
export { ForwardRef as ReactComponent };